/**
 * 申请售后相关API
 */

import request from '@/utils/request'



/**
 * 获取支付订单
 * @returns {AxiosPromise}
 */
export function payLogin(param) {
  return request({
    url: '/pay/login',
    method: 'post',
    ApiBase: false,
    needToken: false,
    loading: false,
    data: param
  })
}

/**
 * 获取支付订单详情
 * @returns {AxiosPromise}
 */
export function payInfo(param) {
  return request({
    url: '/pay/info',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: false,
    data: param
  })
}

/**
 * 获取用戶余额
 * @returns {AxiosPromise}
 */
export function getUserBalance() {
  return request({
    url: '/user/balance',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: false
  })
}

/**
 * 转换币种金额
 * @returns {AxiosPromise}
 */
export function payTradeRate(params) {
  return request({
    url: '/pay/tradeRate',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 转换币种金额+手续费
 * @returns {AxiosPromise}
 */
export function payTradeRateFee(params) {
  return request({
    url: '/pay/actualAmount',
    method: 'get',
    ApiBase: false,
    needToken: true,
    loading: true,
    params
  })
}

/**
 * 发起支付
 * @returns {AxiosPromise}
 */
export function paymentPay(params) {
  return request({
    url: '/payment/pay',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 获取用户交易记录
 * @returns {AxiosPromise}
 */
export function dealTransactions(params) {
  return request({
    url: '/trade/record/list',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 获取交易详情
 * @returns {AxiosPromise}
 */
export function dealDetails(params) {
  return request({
    url: '/trade/record/info',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 获取用户未付款交易
 * @returns {AxiosPromise}
 */
export function unpaidList() {
  return request({
    url: '/trade/record/unpaid/list',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: false
  })
}

/**
 * 获取用户余额记录
 * @returns {AxiosPromise}
 */
export function balanceRecord(params) {
  return request({
    url: '/account/record/list',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 获取用户余额详情
 * @returns {AxiosPromise}
 */
export function balanceInfo(params) {
  return request({
    url: '/account/record/info',
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 获取支付宝支付二维码
 *tradeType
 *sn
 *params
 * @returns {AxiosPromise}
 */
export function getPayQrCode(tradeType, sn, params) {
  return request({
    url: `/order/pay/${tradeType}/${sn}`,
    method: 'get',
    ApiBase: false,
    needToken: true,
    loading: true,
    params
  })
}

/**
 * 获取微信扫描支付的状态
 *weixin_trade_sn
 * @returns {AxiosPromise}
 */
export function whileWeixinPaySuccess(trade_type, weixin_trade_sn) {
  return request({
    url: `/order/pay/weixin/status/${trade_type}/${weixin_trade_sn}`,
    method: 'get',
    ApiBase: false,
    needToken: true,
    loading: false,
    timeout: 30000
  })
}

/**
 * 最近转账
 * @returns {AxiosPromise}
 */
export function lastTransfer() {
  return request({
    url: `/transfer/recently_transfer`,
    method: 'get',
    ApiBase: false,
    needToken: true,
    loading: true,
  })
}

/**
 * 转账手机号/邮箱验证
 * param
 * @returns {AxiosPromise}
 */
export function regTransferWay(param) {
  return request({
    url: `/transfer/verify_account`,
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: param
  })
}

/**
 * 转账申请
 * params
 * @returns {AxiosPromise}
 */
export function transferApply(params) {
  return request({
    url: `/transfer/apply`,
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 支付回调
 * params
 * @returns {AxiosPromise}
 */
export function payForward(params) {
  return request({
    url: `/payment/result`,
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 转入银行帐号列表
 * params
 * @returns {AxiosPromise}
 */
export function bankAccountList(params) {
  return request({
    url: `/recharge/bank_account_list`,
    method: 'post',
    ApiBase: false,
    needToken: true,
    loading: true,
    data: params
  })
}